/* eslint-disable react-hooks/exhaustive-deps */
import { useMemo, useCallback } from 'react';
import isUndefined from 'lodash/isUndefined';
import HeatmapService from '@Pages/Heatmap/HeatmapService';
import { setSkipNextHeatmapTracking } from '@Pages/Heatmap/analytics';

export default function useSortByActivity(params, data, isRow) {
  const isSortByActivityActive = useMemo(() => {
    const sort = HeatmapService.getSortParams();
    return sort && sort.isRow === isRow && sort.index === data.index;
  }, [data]);

  const isAscending = useMemo(() => {
    const sort = HeatmapService.getSortParams();
    return isSortByActivityActive && sort.ascending;
  }, [isSortByActivityActive, data]);

  const sortByActivity = useCallback(
    (ascending) => {
      const sort = HeatmapService.getSortParams();
      if (isUndefined(ascending)) {
        if (isSortByActivityActive) {
          HeatmapService.resetSortByActivity();
        } else {
          HeatmapService.sortMatrixByActivity(data.index, !isRow, false);
        }
      } else {
        // Ignore click on arrow if heatmap already sorted in current direction
        if (sort && sort.ascending === ascending && sort.isRow === isRow && sort.index === data.index) {
          return;
        }
        HeatmapService.sortMatrixByActivity(data.index, !isRow, ascending);
      }

      // Do not track when sorting applied
      setSkipNextHeatmapTracking(true);
    },
    [isSortByActivityActive, data]
  );

  return {
    isSortByActivityActive,
    isAscending,
    sortByActivity,
  };
}
